<template>
    <v-container class="pa-0">
        <v-row>
            <v-col cols="12" md="9" class="py-0">
                <h2>
                    <TranslatableStringComponent
                        :tstring="{ string: 'yourCart' }"
                    />
                </h2>
            </v-col>
            <!-- <v-col
                cols="12"
                md="3"
                class="d-flex justify-end align-center py-0"
            >
                <v-btn
                    v-if="cartProducts.length > 0"
                    block
                    small
                    :loading="availabilityLoading"
                    @click="checkProductAvailabilityInRealTimeInventory"
                >
                    <TranslatableStringComponent
                        :tstring="{ string: 'checkAvailability' }"
                    />
                </v-btn>
            </v-col> -->
        </v-row>
        <v-row column justify-center align-center>
            <v-col
                cols="12"
                md="12"
                class="py-0"
                v-show="
                    getUnavailableProductListInElastic &&
                    getUnavailableProductListInElastic.length > 0
                "
            >
                <v-alert
                    color="warning"
                    type="info"
                    dense
                    outlined
                    class="mb-0"
                >
                    <div class="d-flex justify-space-between">
                        <TranslatableStringComponent
                            :tstring="{ string: 'unavailableProductAlert' }"
                        />
                        <v-btn
                            color="warning"
                            style="font-size: 14px"
                            class="ml-2"
                            small
                            inline
                            @click="$vuetify.goTo(target, options)"
                            ><TranslatableStringComponent
                                :tstring="{ string: 'view' }"
                        /></v-btn>
                    </div>
                </v-alert> </v-col
        ></v-row>
        <v-row column justify-center align-center>
            <v-col
                cols="12"
                md="12"
                class="py-0"
                v-show="isSavedcartUpdated && isSavedCartOwned"
            >
                <v-alert
                    color="primary"
                    type="info"
                    dense
                    outlined
                    class="mb-0"
                >
                    <div>
                        <TranslatableStringComponent
                            :tstring="{ string: 'cartUpdateMessage' }"
                        />

                        <v-btn
                            color="primary"
                            style="font-size: 14px"
                            class="ml-2"
                            small
                            inline
                            :loading="updateCartLoader"
                            @click="labelCart('update')"
                            ><TranslatableStringComponent
                                :tstring="{ string: 'update' }"
                        /></v-btn>

                        <v-btn
                            color="primary"
                            style="font-size: 14px"
                            class="ml-2"
                            :loading="saveCartLoader"
                            small
                            @click="labelCart('save')"
                            ><TranslatableStringComponent
                                :tstring="{ string: 'save' }"
                        /></v-btn>
                    </div>
                </v-alert>
            </v-col>
            <v-col v-if="cartProducts.length > 0" cols="12">
                <v-alert
                    v-if="isPriceListMismatched && appliedPriceList.length > 0"
                    outlined
                    color="primary"
                    type="info"
                    ><TranslatableStringComponent
                        :tstring="{ string: 'savedCartsDefaultMessage' }"
                /></v-alert>
                <div v-for="(item, index) in cartProducts" :key="index">
                    <CardSingleSKUMobile
                        v-if="$vuetify.breakpoint.smAndDown"
                        :ref="
                            item.isAvailable
                                ? 'availableItem'
                                : 'unavailableItem'
                        "
                        :item="item"
                        img-crop="fill"
                        :checkout="true"
                    />
                    <CardSingleSKU
                        v-else
                        :item="item"
                        :ref="
                            item.isAvailable
                                ? 'availableItem'
                                : 'unavailableItem'
                        "
                        img-crop="fill"
                        :checkout="true"
                    />
                </div>
                <div
                    class="d-flex justify-space-between flex-column flex-md-row"
                >
                    <div class="mb-3 mb-sm-0">
                        <v-btn
                            text
                            color="primary"
                            :to="
                                getStaticLocalePath({
                                    type: 'page',
                                    slugName: 'shop',
                                })
                            "
                            class="pl-0"
                        >
                            <fa :icon="['fal', 'arrow-left']" class="mr-2" />
                            <TranslatableStringComponent
                                :tstring="{ string: 'continueShopping' }"
                            />
                        </v-btn>
                    </div>

                    <div
                        class="d-flex justify-md-space-between justify-space-around flex-wrap"
                    >
                        <v-btn
                            v-if="isLoggedIn"
                            right
                            small
                            :class="`${shakeApplied} mr-2 mb-2`"
                            :loading="saveCartLoader"
                            :depressed="isCartSaved"
                            :style="`${isCartSaved && 'pointer-events: none;'}`"
                            :color="`${isCartSaved ? 'success' : 'primary'}`"
                            @click="labelCart('save')"
                            ><TranslatableStringComponent
                                :tstring="{
                                    string: `${saveCartBtnLabel}`,
                                }" /><fa
                                v-if="isCartSaved"
                                :icon="['fal', 'check']"
                                class="ml-2"
                                style="color: #fff" /><fa
                                v-if="!isCartSaved"
                                :icon="['fal', 'bookmark']"
                                class="ml-2"
                                style="color: #fff"
                        /></v-btn>
                        <!-- :color="`${isCartSaved && 'secondary'}`" -->
                        <v-btn
                            v-if="isCartSaved"
                            right
                            small
                            :class="`${shakeApplied} mr-2 mb-4`"
                            color="primary"
                            @click="displayShareableLink()"
                        >
                            <TranslatableStringComponent
                                :tstring="{
                                    string: `${shareCartBtnLabel}`,
                                }" /><fa
                                v-if="isCartSaved"
                                :icon="['fal', 'share-alt']"
                                class="ml-2"
                                style="color: #fff" /><fa
                                v-if="!isCartSaved"
                                :icon="['fal', 'share-alt']"
                                class="ml-2"
                                style="color: #fff"
                        /></v-btn>
                        <v-btn
                            v-else
                            right
                            small
                            :class="`${shakeApplied} mr-2 mb-4`"
                            :loading="saveCartLoader"
                            :depressed="isCartSaved"
                            :style="`${isCartSaved && 'pointer-events: none;'}`"
                            :color="`${!isCartSaved && 'primary'}`"
                            @click="labelCart('share')"
                            ><TranslatableStringComponent
                                :tstring="{
                                    string: `${shareCartBtnLabel}`,
                                }" /><fa
                                v-if="isCartSaved"
                                :icon="['fal', 'share-alt']"
                                class="ml-2"
                                style="color: #fff" /><fa
                                v-if="!isCartSaved"
                                :icon="['fal', 'share-alt']"
                                class="ml-2"
                                style="color: #fff"
                        /></v-btn>
                        <v-btn
                            right
                            small
                            class="mr-2 mb-4"
                            @click="clearCart()"
                            ><TranslatableStringComponent
                                :tstring="{ string: 'clearCart' }" />
                            <fa :icon="['fal', 'times']" class="ml-2"
                        /></v-btn>
                    </div>
                </div>

                <div v-if="isSavedcartUpdated && isSavedCartOwned" class="pt-5">
                    <fa
                        :icon="['fal', 'info-circle']"
                        class="fa-md mr-2"
                        style="color: #000"
                    /><TranslatableStringComponent
                        :tstring="{ string: 'cartUpdateMessage' }"
                    />
                    <div class="d-flex justify-start ml-3">
                        <v-btn
                            color="primary"
                            style="font-size: 12px"
                            class="ma-2"
                            small
                            inline
                            :loading="updateCartLoader"
                            @click="labelCart('update')"
                            ><TranslatableStringComponent
                                :tstring="{ string: 'update' }"
                        /></v-btn>

                        <v-btn
                            color="primary"
                            style="font-size: 12px"
                            class="ma-2"
                            :loading="saveCartLoader"
                            small
                            @click="labelCart('save')"
                            ><TranslatableStringComponent
                                :tstring="{ string: 'save' }"
                        /></v-btn>
                    </div>
                </div>
            </v-col>
            <v-col v-else
                ><TranslatableStringComponent
                    :tstring="{ string: 'yourCartIsEmpty' }" />
                <nuxt-link
                    :to="
                        getStaticLocalePath({
                            type: 'page',
                            slugName: 'shop',
                        })
                    "
                    ><TranslatableStringComponent
                        :tstring="{ string: 'returnToShopPage' }" /></nuxt-link
            ></v-col>
        </v-row>
        <v-overlay :value="overlay">
            <p class="body-1">
                <TranslatableStringComponent
                    :tstring="{ string: 'fetchingCartItems' }"
                />
                ...
            </p>
        </v-overlay>
        <v-dialog v-model="showModal" width="500" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-4" primary-title
                    ><TranslatableStringComponent
                        :tstring="{ string: 'adjustForPkgQtyTitle' }"
                /></v-card-title>
                <v-card-text>
                    <p>
                        <TranslatableStringComponent
                            :tstring="{ string: 'adjustForPkgQtyMessage' }"
                        />
                    </p>
                    <p>
                        <strong>{{
                            `${pnsWithIncorrectProdQty.join(', ')}`
                        }}</strong>
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="handleDialog()">
                        <TranslatableStringComponent
                            :tstring="{ string: 'close' }"
                        />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="showProductsExistInCartWarning"
            width="500"
            persistent
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-4" primary-title
                    ><TranslatableStringComponent
                        :tstring="{ string: 'itemFoundInExistingCart' }"
                /></v-card-title>
                <v-card-text>
                    <TranslatableBlockComponent
                        :tstring="{
                            string: 'loadingSharedCartOverExistingCartNote',
                        }"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click="continueLoadingNewSharedCart()"
                    >
                        <TranslatableStringComponent
                            :tstring="{ string: 'continue' }"
                        />
                    </v-btn>
                    <v-btn
                        color="primary"
                        text
                        @click="cancelLoadingNewSavedCart()"
                    >
                        <TranslatableStringComponent
                            :tstring="{ string: 'cancel' }"
                        />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <LabelSavedCartDialog
            :showSavedCardLabelForm="showSavedCardLabelForm"
            :label="label"
            @saveLabel="saveLabel"
            @closeDialog="showSavedCardLabelForm = false"
        />

        <DevOutput>
            <pre v-if="cartProducts && cartProducts.length > 0">{{
                cartProducts
            }}</pre>
        </DevOutput>
    </v-container>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import handleSnackbar from '~/mixins/handleSnackbar'
import CardSingleSKU from '~/components/cards/CardSingleSKU.vue'
import CardSingleSKUMobile from '~/components/cards/CardSingleSKUMobile.vue'
import LabelSavedCartDialog from '~/components/LabelSavedCartDialog.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'
import UnavailableProductWarningModal from '~/components/UnavailableProductWarningModal.vue'
import _ from 'lodash'
export default {
    name: 'CartItems',
    components: {
        CardSingleSKU,
        CardSingleSKUMobile,
        LabelSavedCartDialog,
        TranslatableStringComponent,
        TranslatableBlockComponent,
        UnavailableProductWarningModal,
    },
    mixins: [handleSnackbar],
    props: {
        filters: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            shareableLink: '',
            overlay: false,
            updateCartLoader: false,
            showModal: false,
            showProductsExistInCartWarning: false,
            showSavedCardLabelForm: false,
            saveType: null,
            stepperValue: 1,
            label: null,
            loading: false,
        }
    },
    computed: {
        ...mapState('savedCarts', [
            'saveCartLoader',
            'applyShake',
            'currentSavedCartId',
            'savedCartLabel',
            'savedCarts',
            'maxSavedCartLimit',
        ]),
        ...mapState('bulkOrderPad', ['pnsWithIncorrectProdQty']),
        ...mapState('priceList', ['appliedPriceList']),
        ...mapGetters({
            cartSubtotal: 'cart/fetchCartSubtotal',
            isSavedcartUpdated: 'savedCarts/isSavedcartUpdated',
            isCartSaved: 'savedCarts/isCartSaved',
            isSavedCartOwned: 'savedCarts/isSavedCartOwned',
            isPriceListMismatched: 'priceList/isPriceListMismatched',
            isLoggedIn: 'auth/isLoggedIn',
            isProduction: 'auth/isProduction',
            fetchCartProducts: 'cart/fetchCartProducts',
            abandonedCartPresent: 'abandonedCartNew/isAbandonedCartPresent',
            // cartProductAvailability:
            //     'realTimeInventoryData/fetchCartProductsAvailability',
            // availabilityLoading:
            //     'realTimeInventoryData/fetchAvailabilityLoadingState',
            getUnavailableProductListInElastic:
                'cart/getUnavailableProductListInElastic',
        }),
        shakeApplied() {
            return this.applyShake ? 'input-shake' : ''
        },
        cartProducts() {
            const temp = this.fetchCartProducts.map((product) => {
                const locale = this.$i18n.locale
                return {
                    ...product,
                    name: product[`name_${locale}`],
                    quantityInCart: product.prod_quantity,
                }
            })
            return temp.sort((a, b) => {
                return a.isAvailable === b.isAvailable
                    ? 0
                    : a.isAvailable
                    ? -1
                    : 1
            })
        },
        saveCartBtnLabel() {
            return this.isCartSaved ? 'cartSaved' : 'saveCart'
        },
        shareCartBtnLabel() {
            return this.isCartSaved ? 'shareCart' : 'shareCart'
        },
        currentSavedCartId() {
            return localStorage.getItem('c3SavedCarts')
                ? JSON.parse(localStorage.getItem('c3SavedCarts'))
                      .currentSavedCartId
                : []
        },
        target() {
            return this.$refs.unavailableItem?.[0]
        },
        options() {
            return {
                duration: 450,
                offset: 50,
                easing: 'easeInOutCubic',
            }
        },
    },
    watch: {
        cartProducts(newVal, oldVal) {
            if (newVal.length === 0 && this.appliedPriceList.length > 0) {
                this.$store.commit('priceList/setSelectedPriceListId', '')
                this.$store.commit('priceList/setAppliedPriceList', [])
                const message = 'pricingRevertedToYourApprovedPricelist'
                this.hitSnackbar({ string: message }, null)
            }
            // if (newVal.length > oldVal.length)
            //     this.checkProductAvailabilityInRealTimeInventory()
        },
    },
    async mounted() {
        if (this.pnsWithIncorrectProdQty.length > 0) {
            this.showModal = true
        }
        if (this.$route.query.savedcartId) {
            await this.handleLoadingOfSharedCart()
        }
        if (this.cartProducts.length > 0) {
            await this.checkProductAvailibilityInElastic()
        }
        // await this.checkPrsoductAvailabilityInRealTimeInventory()
    },
    methods: {
        async checkProductAvailibilityInElastic() {
            const cartProducts = localStorage.getItem('c3cart')
                ? JSON.parse(localStorage.getItem('c3cart')).cartProducts
                : []
            await this.$store.dispatch(
                'cart/checkProductAvailibilityInElastic',
                { products: cartProducts }
            )
            if (
                this.unavailableProductList &&
                this.unavailableProductList.length > 0
            ) {
                const message = 'cartItemsAreCurrentlyUnavailable'
                this.hitSnackbar(
                    {
                        string: message,
                        variables: [
                            { var: this.unavailableProductList.length },
                        ],
                    },
                    null
                )
            }
        },

        // async checkProductAvailabilityInRealTimeInventory() {
        //     const cartProducts = localStorage.getItem('c3cart')
        //         ? JSON.parse(localStorage.getItem('c3cart')).cartProducts
        //         : []
        //     if (cartProducts.length > 0) {
        //         await this.$store.dispatch(
        //             'realTimeInventoryData/checkProductAvailabilityInRealTimeInventory',
        //             { products: cartProducts, source: 'cart' }
        //         )
        //     }
        // },
        clearCart() {
            this.$store.dispatch('cart/clearCart')
            this.$store.dispatch('savedCarts/clearSavedCartData')
            if (this.abandonedCartPresent)
                this.$store.dispatch('abandonedCartNew/deleteErpCart')
            if (!_.isEmpty(this.$router.history.current.query)) {
                this.$router.replace({
                    path: this.$route.path,
                    query: null,
                })
            }
        },
        displayShareableLink() {
            this.$store.commit('savedCarts/displayShareableLink', true)
        },

        labelCart(type) {
            this.saveType = type
            switch (type) {
                case 'save':
                    this.label = ''
                    break
                case 'share':
                    this.label = ''
                    break
                case 'update':
                    this.label = this.savedCartLabel
                    break
            }
            this.showSavedCardLabelForm = true
        },
        saveLabel(label) {
            if (label.length > 0)
                this.$store.commit('savedCarts/setSavedCartLabel', label)
            if (this.saveType === 'update') this.updateSavedCart()
            else this.saveCart()
        },
        async saveCart() {
            if (this.savedCarts.length >= this.maxSavedCartLimit)
                this.hitSnackbar(
                    {
                        string: [
                            'youHaveReachedTheMaxOfSavedCarts',
                            'deleteSavedCartsMessage',
                        ],
                    },
                    null,
                    'warning',
                    10000
                )
            else {
                this.showSavedCardLabelForm = false
                this.saveType === 'share' &&
                    this.$store.commit('savedCarts/displayShareableLink', true)
                await this.$store.dispatch('savedCarts/createSavedCart')
            }
        },
        async updateSavedCart() {
            this.showSavedCardLabelForm = false
            this.updateCartLoader = true

            await this.$store.dispatch('savedCarts/updateSavedCart')

            this.updateCartLoader = false
        },
        async fetchSavedCartById() {
            this.overlay = true
            this.showProductsExistInCartWarning = false
            await this.$store.dispatch(
                'savedCarts/fetchSavedCartById',
                this.$route.query.savedcartId
            )
            if (this.isLoggedIn) {
                if (this.abandonedCartPresent)
                    this.$store.dispatch('cart/updateErpCart', null)
            }
            this.overlay = false
            await this.checkProductAvailibilityInElastic()
        },
        cancelLoadingNewSavedCart() {
            this.showProductsExistInCartWarning = false
            if (
                this.currentSavedCartId &&
                !_.isEmpty(this.$router.history.current.query)
            ) {
                if (this.$route.query.savedcartId !== this.currentSavedCartId)
                    this.routerPush({
                        type: 'page',
                        slugName: 'cart',
                        query: { savedcartId: this.currentSavedCartId },
                    })
            } else {
                this.routerPush({
                    type: 'page',
                    slugName: 'cart',
                    query: {},
                })
            }
        },
        async continueLoadingNewSharedCart() {
            if (this.currentSavedCartId) {
                // loading a new shared cart url over a previous shared cart url
                if (this.$route.query.savedcartId !== this.currentSavedCartId) {
                    await this.fetchSavedCartById()
                }
                // when url is same do nothing
            } else this.fetchSavedCartById()
        },
        handleDialog() {
            this.showModal = false
            this.$store.commit('bulkOrderPad/EmptyPnsWithIncorrectProdQty', [])
        },
        async handleLoadingOfSharedCart() {
            const cartProducts = localStorage.getItem('c3cart')
                ? JSON.parse(localStorage.getItem('c3cart')).cartProducts
                : []
            if (cartProducts.length > 0) {
                // when products exist in cart
                this.showProductsExistInCartWarning = true
            } else {
                // when 0 products exist in cart
                await this.fetchSavedCartById()
            }
        },
    },
}
</script>
